module.exports = __webpack_public_path__ + "img/image.0bda071f.png";